import { IRootState } from 'app/shared/reducers';
import { isMobileDevice } from 'app/shared/util/methode-util';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { ViewName } from '../../../tools/constants';
import DesktopAssignmentContract from '../../desktop/desktop-assignement-contract/assignement-contract';
import MobileAssignmentContract from '../../mobile/mobile-assignement-contract/assignement-contract';

const AssignmentContract = props => {
  const { globalObjectState, subscriptionList, updateObject, accoutAssignementCms } = props;
  const configuration: any = useSelector<IRootState>(state => state.global.configuration);
  const [checked, setChecked] = useState(false);
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const [notAttached, setNotAttached] = useState([]);
  const refHeight = useRef(null);
  const [avatarTitle, setAvatarTitle] = useState<string>(accoutAssignementCms?.assaignement_contract?.subscription_match_avatar_text);

  useEffect(() => {
    subscriptionList
      .filter(subscription => subscription.valid === false)
      .map((item, key) =>
        notAttached.push({
          number: item.number,
          mineSubscription: true,
          email: item.email,
          valid: item.valid,
          clientNumber: item.clientNumber,
        })
      );
    setNotAttached(notAttached);
    globalObjectState.subscriptionsNotAttachement = notAttached;
  }, []);

  globalObjectState.currentView = ViewName.EMAIL_ACCOUNT_ATTACHEMENT;

  const chekedFunc = () => {
    updateObject(ViewName.EMAIL_ACCOUNT_ATTACHEMENT, { moreSubscription: !checked }, 'array');

    setChecked(!checked);
  };
  const getNotAttachedSusbscriptionList = (adhesionNumber: any, status: boolean) => {
    notAttached.forEach(item => {
      if (item?.number === adhesionNumber) {
        item.mineSubscription = status;
      }
    });
    setNotAttached(notAttached);

    globalObjectState.subscriptionsNotAttachement = notAttached;
  };

  useEffect(() => {
    const indexBS = avatarTitle?.indexOf('S{{');
    const indexBP = avatarTitle?.indexOf('P{{');
    const indexES = avatarTitle?.indexOf('}}S');
    const indexEP = avatarTitle?.indexOf('}}P');
    let newAvatarTitle = avatarTitle?.substring(0, indexBS);
    if (subscriptionList !== undefined && subscriptionList !== null) {
      if (subscriptionList?.length > 1) {
        newAvatarTitle += avatarTitle?.substring(indexBP + 3, indexEP);
      } else {
        newAvatarTitle += avatarTitle?.substring(indexBS + 3, indexES);
      }
      newAvatarTitle += avatarTitle?.substring(indexEP + 3);
      setAvatarTitle(newAvatarTitle);
    }
  }, [subscriptionList])

  const params = {
    ...props,
    refHeight,
    avatar,
    avatarTitle,
    checked,
    chekedFunc,
    getNotAttachedSusbscriptionList
  }
  return (
    <>
      {isMobileDevice(configuration) ?
        <MobileAssignmentContract {...params} />
        :
        <DesktopAssignmentContract {...params} />
      }
    </>
  );
};

export default AssignmentContract;
